import { memo, FC } from "react";
import { useSectionNavigationContext } from "../section-navigation-context";
import { SectionNavigationListProps } from "./interfaces";

const SectionNavigationList: FC<SectionNavigationListProps> = ({
  index,
  isSubsection = false,
  children,
  ...rest
}) => {
  const { getListProps } = useSectionNavigationContext();

  if (!getListProps) {
    throw new Error(
      "SectionNavigation.List component requires getListProps to be defined",
    );
  }

  return (
    <ul {...getListProps({ isSubsection, index, ...rest })}>{children}</ul>
  );
};

export default memo(SectionNavigationList);
